import { render } from "./TriggerableDropdown.vue?vue&type=template&id=39fad70c&bindings={}"
import script from "./TriggerableDropdown.vue?vue&type=script&lang=ts"
export * from "./TriggerableDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script